function Nav() {
	this.build();
}

Nav.prototype.build = function () {
	$('.open-navs').on('click', function () {
		$('body').addClass('nav-is-opened');
	});

	$('.close-navs').on('click', function () {
		$('body').removeClass('nav-is-opened');
	});


	ScrollTrigger.create({
		trigger: ".page-container",
		start: "top -60",
		toggleClass: {
			targets: document.body, className: "nav-scrolled"
		}
	});
};
